import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { PropertyGridComponent } from '../property-grid/property-grid.component';
import {
  CdkDragStart, CdkDragMove, CdkDragDrop, moveItemInArray,
  copyArrayItem, transferArrayItem
} from '@angular/cdk/drag-drop';
import { EditorAceComponent } from '../../controls/editor-ace/editor-ace.component';
import { ConfigWindow } from 'src/app/models/config-window';

@Component({
  selector: 'app-property-grid-column',
  templateUrl: './property-grid-column.component.html',
  styleUrls: ['./property-grid-column.component.css']
})
export class PropertyGridColumnComponent extends PropertyGridComponent implements OnInit {
  @ViewChild("editorAceChidOptions", { static: false }) public editorAceChidOptions: EditorAceComponent;

  @Input() IsExtendableTable:boolean=false;
  public OnInit() {
    this.subControl.ControlType = 'Column';
  }

  // public set subControl(value:any){

  //   this.subControl =value;
  // }
  public UpdateEditor(subControl?: any) {
    this.subControl = subControl;
    if (this.subControl && this.subControl.ControlType == 'Column') {
      if (this.editorAceChidOptions)
        this.editorAceChidOptions.Update(this.subControl.ChildOptions);
    }
   
  }
  public OnChangeHandlerChildOptions(event) {
    this.subControl.ChildOptions = event;
    //this.UpdateEditor(this.subControl);
  }
  public ControlTypeChanged(event) {

    debugger;
    if (this.subControl.ControlType == 'None') {
      this.subControl.Control = null;
    }
    else {
      this.subControl.Control = this.utility.GetBasicControlModel(this.subControl.ControlType, this.subControl.ControlType);
    }
  }
  verProperty(index): any {
    let config: ConfigWindow = new ConfigWindow();
    config.classWindow = 'info';
    config.titleWindow = "Propiedades";
    config.returnInstance = false;
    config.modal = false;
    config.width = 600;
    config.height = 600;
    config.viewOk = false;
    config.cancel = 'Cerrar';
    let windowModel: any = {
      subControl:this.subControl.Control,
      subControlIndex: -1
    };

    this.utility.OpenWindow('PropertyGridControlsComponent',
      config, windowModel).then(dataResult => {
        // console.log(dataResult);
        debugger;
        dataResult.onClosePromise.then(dataResultOnClose => {
          // console.log(dataResultOnClose);
          debugger;

        });

      })

  }
}
